<template>
  <div>
    <Head :title="__(title)" />
    <div class="flex items-center justify-between mb-6">
      <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">{{ __('Name') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Slug') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Details') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="template in templates.data" :key="template.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="this.route('templates.edit', template.id)">
                {{ template.name }}
              </Link>
            </td>
              <td class="border-t">
                  <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="this.route('templates.edit', template.id)">
                      {{ template.slug }}
                  </Link>
              </td>
              <td class="border-t">
                  <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="this.route('templates.edit', template.id)">
                      {{ template.details }}
                  </Link>
              </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="this.route('templates.edit', template.id)" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="templates.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No templates found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="templates.links" />
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  metaInfo: { title: 'Email Templates' },
  components: {
    Icon,
    Link,
    Head,
    Pagination,
      SearchInput,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
      templates: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('templates'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
